<template>
  <div class="daily-container">
    <van-nav-bar
      title="月报"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="daily-content">
      <van-tabs v-model="active" @change="changeTabs">
        <van-tab title="下属" :name="2"></van-tab>
        <van-tab title="我的" :name="3"></van-tab>
      </van-tabs>
      <div class="daily-search">
        <div @click="changeTime">{{currentDateStr}}</div>
        <van-dropdown-menu>
          <van-dropdown-item @change="changeStatus" v-model="typeValue" :options="typeOption" />
        </van-dropdown-menu>
      </div>
      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="daily-item" @click="handleClick(item)" v-for="(item, index) in taskList" :key="index">
        <div class="member-info">
          <img style="width: 1.07rem;height: 1.07rem;margin-right: .2rem" :src="item.avatar" />
          <div>
            <div>{{item.staffName}}</div>
            <div>部门：{{item.officeName}}</div>
            <div>职位：{{item.position}}</div>
          </div>
        </div>
        <div :style="item.taskStatus === 0 ? 'color: #F59A23' : item.taskStatus === 1 ? 'color: #02A7F0' : ''">{{handelRender(item)}}</div>
      </div>
      <div class="daily-footer">
        <div class="daily-submit" @click="jumpEdit">写月报</div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月日"
        @confirm="(data) => onConfirm(data)"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { setMainStaff, getTaskList } from '../axios/services'
import { mapState } from 'vuex'
import { Toast } from 'vant';
export default {
  data() {
    return {
      searchValue: '',
      typeValue: 3,
      typeOption: [
        { text: '未填写', value: 0},
        { text: '未审核', value: 1},
        { text: '已审核', value: 2},
        { text: '全部', value: 3},
      ],
      showPicker: false,
      currentDate: new Date(),
      currentDateStr: this.handleTime(new Date()),
      taskList: [],
      searchWord: '',
      active: 3,
      // color: ''
    }
  },
  computed: {
    ...mapState(['initialData', 'dailyData'])
  },
  methods: {
    onClickLeft() {
      window.location.href = "jsToOc://back";
    },
    changeTabs(e) {
      this.active = e;
      this.$store.commit('setConditionType', e)
      this.getList()
    },
    handleTime(date) {
      return date.getFullYear()+'-'+this.checkTime(date.getMonth()+1)
    },
    checkTime(i) {
      if(i<10){ i='0'+i } return i
    },
    changeTime() {
      this.showPicker = true
    },
    changeStatus() {
      this.getList()
    },
    onConfirm(date) {
      this.currentDateStr = this.handleTime(date)
      this.showPicker = false
      this.getList()
    },
    handelRender(item) {
      let str = ''
      switch(item.taskStatus) {
        case 0:
          str = '未填写'
          break;
        case 1:
          str = '未审核'
          
          break;
        case 2:
          str = '已审核'
          break;
        default:
          str = ''
          break;
      }
      return str
    },
    onSearch() {
      this.getList()
    },
    jumpEdit() {
      this.$router.push('/month-report-edit')
    },
    handleClick(item) {
      if(item.staffId === this.dailyData.staffId) {
        if(item.taskStatus === 0) {
          this.$router.push('/month-report-edit')
        }
        if(item.taskStatus !== 0 && item.reportId) {
          this.$router.push(`month-report-detail/${item.reportId}`)
        }
      }
      else if(item.staffId !== this.dailyData.staffId && item.reportId) {
        this.$router.push(`daily-detail/${item.reportId}`)
      }else {
        Toast('该用户还没有填写月报，不能查看')
      }
    },
    getList() {
      const data = {
        companyId: this.dailyData.companyId,
        reportDate: this.currentDateStr,
        conditionType: this.active,
        searchWord: this.searchValue,
        reportStatus: this.typeValue
      }
      getTaskList(data).then(res => {
        if(res.data.code === 0) {
          this.taskList = res.data.data
        }else {
          Toast.fail(res.data.msg)
        }
      }) 
    },
    setInitdata() {
      const params = {
        companyId: this.initialData.companyId
      }
      setMainStaff(params).then(res => {
        if(res.data.code === 0) {
          this.$store.commit('setDailyData', res.data.data);
          this.getList()
        }else {
          Toast.fail(res.data.msg)
        }
      })
    }
  },
  created() {
    this.setInitdata()
  },
}
</script>

<style scoped>
  .daily-container {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 2rem;
    background: white;
    position: relative;
  }
  .van-nav-bar /deep/.van-nav-bar__arrow {
    font-size: 22px;
    color: black;
  }
  .van-dropdown-menu {
    width: 3rem;
    height: 1rem;
  }
  .van-dropdown-menu /deep/ .van-dropdown-item__option--active {
    color: #1584FF !important;
  }
  .van-dropdown-menu /deep/ .van-dropdown-menu__title--active {
    color: #1584FF !important;
  }
  .van-dropdown-menu /deep/ .van-dropdown-menu__bar {
    box-shadow: none;
  }
  .daily-search {
    display: flex;
    justify-content: center;
    align-items: baseline;
    /* padding: 0 .2rem; */
  }
  .van-tabs /deep/.van-tabs__line {
    background-color: #1584ff
  }
  .van-search {
    background: #f9f9f9;
  }
  .van-search /deep/ .van-field__control {
    background: #ffffff;
  }
  .active {
    color: #1584FF
  }
  .daily-item {
    width: 9.6rem;
    height: 2.45rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.4rem;
    margin-left: 0.4rem;
    border-bottom: 0.03rem solid #F3F3F3;
  }
  .member-info {
    display: flex;
    align-items: flex-start;
  }
  .daily-submit {
    color: white;
    line-height: 1.17rem;
    text-align: center;
    width: 8.29rem;
    height: 1.17rem;
    background: #1584FF;
    box-shadow: 0rem 0.05rem 0.21rem 0rem #80BCFF;
    border-radius: 0.21rem;
  }
  .daily-footer {
    width: 100%;
    height: 2rem;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>>
